/**
 * Patient Notes Actions
 */
import ServiceInterface from '../../services/service.interface'
import ActionType from '../action.types'
import { constants } from '../../constants'

const patientNotesService = ServiceInterface.PatientNotesService()

export const getPatientNotes = (input) => {
  return async (dispatch) => {
    dispatch({ type: ActionType.GET_PATIENT_NOTES_START })
    try {
      const response = await patientNotesService.getPatientNotes(input)
      if (response.status === constants.MESSAGE.SUCCESS) {
        dispatch({
          type: ActionType.GET_PATIENT_NOTES_SUCCESS,
          payload: response,
        })
        return response
      } else {
        dispatch({
          type: ActionType.GET_PATIENT_NOTES_FAILURE,
          payload: response.message,
        })
        return response
      }
    } catch (error) {
      dispatch({
        type: ActionType.GET_PATIENT_NOTES_FAILURE,
        payload: error.message,
      })
      return { status: 'error', message: error.message }
    }
  }
}

export const getPatientNotesCategories = () => {
  return async (dispatch) => {
    dispatch({ type: ActionType.GET_PATIENT_NOTES_CATEGORIES_START })
    try {
      const response = await patientNotesService.getPatientNotesCategories()
      
      if (response.status === constants.MESSAGE.SUCCESS) {
        dispatch({
          type: ActionType.GET_PATIENT_NOTES_CATEGORIES_SUCCESS,
          payload: response,
        })
        return response
      } else {
        dispatch({
          type: ActionType.GET_PATIENT_NOTES_CATEGORIES_FAILURE,
          payload: response.message,
        })
        return response
      }
    } catch (error) {
      dispatch({
        type: ActionType.GET_PATIENT_NOTES_CATEGORIES_FAILURE,
        payload: error.message,
      })
      return { status: 'error', message: error.message }
    }
  }
}

export const addPatientNote = (input) => {
  return async (dispatch) => {
    dispatch({ type: ActionType.ADD_PATIENT_NOTE_START })
    try {
      const response = await patientNotesService.addPatientNote(input)
      if (response.status === constants.MESSAGE.SUCCESS) {
        dispatch({
          type: ActionType.ADD_PATIENT_NOTE_SUCCESS,
          payload: response,
        })
        return response
      } else {
        dispatch({
          type: ActionType.ADD_PATIENT_NOTE_FAILURE,
          payload: response.message,
        })
        return response
      }
    } catch (error) {
      dispatch({
        type: ActionType.ADD_PATIENT_NOTE_FAILURE,
        payload: error.message,
      })
      return { status: 'error', message: error.message }
    }
  }
}

export const updatePatientNote = (input) => {
  return async (dispatch) => {
    dispatch({ type: ActionType.UPDATE_PATIENT_NOTE_START })
    try {
      const response = await patientNotesService.updatePatientNote(input)
      if (response.status === constants.MESSAGE.SUCCESS) {
        dispatch({
          type: ActionType.UPDATE_PATIENT_NOTE_SUCCESS,
          payload: response,
        })
        return response
      } else {
        dispatch({
          type: ActionType.UPDATE_PATIENT_NOTE_FAILURE,
          payload: response.message,
        })
        return response
      }
    } catch (error) {
      dispatch({
        type: ActionType.UPDATE_PATIENT_NOTE_FAILURE,
        payload: error.message,
      })
      return { status: 'error', message: error.message }
    }
  }
}

export const deletePatientNote = (id) => {
  return async (dispatch) => {
    dispatch({ type: ActionType.DELETE_PATIENT_NOTE_START })
    try {
      const response = await patientNotesService.deletePatientNote(id)
      if (response.status === constants.MESSAGE.SUCCESS) {
        dispatch({
          type: ActionType.DELETE_PATIENT_NOTE_SUCCESS,
          payload: { id },
        })
        return response
      } else {
        dispatch({
          type: ActionType.DELETE_PATIENT_NOTE_FAILURE,
          payload: response.message,
        })
        return response
      }
    } catch (error) {
      dispatch({
        type: ActionType.DELETE_PATIENT_NOTE_FAILURE,
        payload: error.message,
      })
      return { status: 'error', message: error.message }
    }
  }
}

export const getPatientNotesCount = (patientId) => {
  return async (dispatch) => {
    dispatch({ type: ActionType.GET_PATIENT_NOTES_COUNT_START })
    try {
      const response = await patientNotesService.getPatientNotesCount(patientId)
      if (response.status === constants.MESSAGE.SUCCESS) {
        dispatch({
          type: ActionType.GET_PATIENT_NOTES_COUNT_SUCCESS,
          payload: response,
        })
        return response
      } else {
        dispatch({
          type: ActionType.GET_PATIENT_NOTES_COUNT_FAILURE,
          payload: response.message,
        })
        return response
      }
    } catch (error) {
      dispatch({
        type: ActionType.GET_PATIENT_NOTES_COUNT_FAILURE,
        payload: error.message,
      })
      return { status: 'error', message: error.message }
    }
  }
}